module.exports = __webpack_public_path__ + "a397d89c44b9bd679ffe17cfe4a0dcde.ttf";